export const AI_CHARACTERISTIC_ICON: Record<string, string> = {
  Submissive: '🙏🏼',
  Neutral: '☺️',
  Flirty: '🔥',
  Naughty: '❤️‍🔥',
  Dominant: '😈',
};
